import type { DiscoveryGetTrends200PageAllOfThreeContentItem } from './discoveryGetTrends200PageAllOfThreeContentItem';

export type DiscoveryGetTrends200PageAllOfThree = {
  content?: DiscoveryGetTrends200PageAllOfThreeContentItem[];
};
